import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';

function Redirect({ to }) {
  window.location.href = to;
  return null;
}
import { AuthProvider } from './contexts/AuthContext';
import ClientLayout from './components/ClientLayout';
import AdminLayout from './components/AdminLayout';
import { ProtectedRoute } from './components/ProtectedRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import AuthCallback from './pages/AuthCallback';
import Events from './pages/Events';
import EventDetail from './pages/EventDetail';
import MenuPage from './pages/Menu';
import Prestations from './pages/Prestations';
import Entreprises from './pages/Entreprises';
import Associations from './pages/Associations';
import Reservation from './pages/Reservation';
import RejoindrePartie from './pages/RejoindrePartie';
import Contact from './pages/Contact';
import MonEspace from './pages/MonEspace';
import Profile from './pages/Profile';
import ResetPassword from './pages/ResetPassword';
import AdminDashboard from './pages/admin/Dashboard';
import AdminEvents from './pages/admin/EventsAdmin';
import AdminProducts from './pages/admin/ProductsAdmin';
import AdminCashless from './pages/admin/CashlessAdmin';
import AdminUsers from './pages/admin/UsersAdmin';
import AdminLoyalty from './pages/admin/LoyaltyAdmin';
import AdminClients from './pages/admin/ClientsAdmin';
import AdminRdv from './pages/admin/RdvAdmin';
import AdminSumup from './pages/admin/SumupAdmin';
import AdminBlindTest from './pages/admin/BlindTestAdmin';
import AdminReservations from './pages/admin/ReservationsAdmin';
import AdminPartners from './pages/admin/PartnersAdmin';
import { Toaster } from './components/ui/sonner';
import './App.css';

function AppContent() {
  const location = useLocation();

  // CRITICAL: Handle OAuth callback synchronously before routing
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route element={<ClientLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/events" element={<Events />} />
        <Route path="/events/:id" element={<EventDetail />} />
        <Route path="/carte" element={<MenuPage />} />
        <Route path="/prestations" element={<Prestations />} />
        <Route path="/entreprises" element={<Entreprises />} />
        <Route path="/associations" element={<Associations />} />
        <Route path="/party-live" element={<Redirect to="/api/blindtest/" />} />
        <Route path="/rejoindre" element={<RejoindrePartie />} />
        <Route path="/reservation" element={<Reservation />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/mon-espace" element={<ProtectedRoute><MonEspace /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/play" element={<Redirect to="/api/blindtest/pages/player.html" />} />
      <Route element={<AdminLayout />}>
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/events" element={<AdminEvents />} />
        <Route path="/admin/products" element={<AdminProducts />} />
        <Route path="/admin/cashless" element={<AdminCashless />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/clients" element={<AdminClients />} />
        <Route path="/admin/loyalty" element={<AdminLoyalty />} />
        <Route path="/admin/rdv" element={<AdminRdv />} />
        <Route path="/admin/sumup" element={<AdminSumup />} />
        <Route path="/admin/blindtest" element={<AdminBlindTest />} />
        <Route path="/admin/reservations" element={<AdminReservations />} />
        <Route path="/admin/partners" element={<AdminPartners />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}
